import { apiClient } from "lib/apiClient";

export type UploadCompErrorType = {
  message: string;
};

export const COMP_UPLOAD_PUBLICATION_MODE = {
  MY_COMP: "MY_COMP",
  SENIOR_COMP: "SENIOR_COMP",
} as const;

export type TCompUploadPublicationMode =
  (typeof COMP_UPLOAD_PUBLICATION_MODE)[keyof typeof COMP_UPLOAD_PUBLICATION_MODE];

type Response = {
  validationErrors: UploadCompErrorType[];
  state: "SUCCESS" | "ERROR";
  savedComps: number;
};

export const uploadXlsxFile = async (
  userId: string,
  file: FormData,
  publicationMode: TCompUploadPublicationMode = COMP_UPLOAD_PUBLICATION_MODE.MY_COMP
): Promise<Response> => {
  const response = await apiClient.post(
    `/comps/upload/user/${userId}?publicationMode=${publicationMode}`,
    file
  );

  return response.data;
};
